import React, { Component, Fragment } from "react";
import Sticky from "Components/Sticky";
import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "Icons/back.svg";
import { Table, Button } from "reactstrap";
import { ReactComponent as TrashIcon } from "Icons/trash.svg";
import { ReactComponent as DownloadIcon } from "Icons/download.svg";
import { ReactComponent as UploadIcon } from "Icons/upload-blue.svg";
import Upload from 'Components/Upload';
import { connect } from 'react-redux';
import {
  DOWNLOAD_EVENT_DETAILS_TEMPLATE,
  UPLOAD_RFQS_FOR_EVENT,
  GET_RFQ_EVENT,
  CANCEL_EVENT
} from 'Constants/actionConstants';
import { downloadUrl } from "Utils/index";
import ActionLoader from "Components/ActionLoader/index";

class UploadRfq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      startDate: null,
      endDate: null,
      offset: 0,
      limit: 10,
      uploadPlanDetails: null,
      editId: "",
      downloadTemp: "",
      fileName: "",
    };
  }

  componentDidMount() {
    this.getRFQEvent();
  }

  getRFQEvent = () => {
    const { dispatch, match } = this.props;
    dispatch({
      type: GET_RFQ_EVENT,
      params: {
          eventId: (match.params || {}).eventId,
          rfqType: 1,
          rfqId: (match.params || {}).rfqId
      }
    })
  }

  handleExcelUpload = (e) => {
    this.setState({
      fileUploaded: e.target.files,
    });
  };
  
  handleFileNameStorage = (e) => {
    let { fileName } = this.state;
    const filePath = document.getElementById("validatedCustomFile");
    if (filePath && filePath.value && filePath.value.length > 0) {
      fileName = filePath.value.replace(/.*[\/\\]/, "");
    }
    this.setState({ fileName, fileUploaded: e.target.files });
  };

  onClickEventDownloadTemplate = (type) => {
    const { dispatch, match } = this.props;
    const branchLocalName = localStorage.getItem('branchDetail');
    const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
    
    dispatch({
      type: DOWNLOAD_EVENT_DETAILS_TEMPLATE,
      data: {
        type,
        rfqType: 1,
        eventId: match.params.eventId,
        branchId: name.branch_id,
      },
      onSuccess: (data) => {
        downloadUrl(data.url);
      }
    })
  } 

  submitUploadedFile = () => {
    const { fileUploaded } = this.state;
    const { match, dispatch } = this.props;
    dispatch({
      type: UPLOAD_RFQS_FOR_EVENT,
      file: fileUploaded[0],
      params: {
        type: 1,
        eventId:  match.params.eventId
      },
      onSuccess: () => {
        this.setState({ fileName: '', fileUploaded: '' });
        document.getElementById("validatedCustomFile").value = '';
        this.getRFQEvent();
      }
    })
  }
  onUpload = (file) => {
    const { match, dispatch } = this.props;
    dispatch({
      type: UPLOAD_RFQS_FOR_EVENT,
      file,
      params: {
        type: 2,
        eventId: match.params.eventId
      },
      onSuccess: () => {
        this.getRFQEvent();
      }
    })
  }

  onCancel = () => {
    const { dispatch, history, match} = this.props;
    dispatch({
      type: CANCEL_EVENT,
      data: {
        eventId: match.params.eventId
      },
      onSuccess: () => {
        history.push('/eventManagement');
      }
    })
  }

  onNext = () => {
    const { history, match } = this.props;
    history.push(`/preview/${match.params.eventId}/${match.params.rfqId}`);
  }

  onClickPrevious = () => {
    const { history, match } = this.props;
    history.push(`/event/create/${match.params.eventId}/${match.params.rfqId}`);
  }

  render() {
    const { fileName } = this.state;
    const { eventDetails, match, loader } = this.props;
    return (
      <Sticky>
        {loader && <ActionLoader fixed={true} />}
        <div
          className=""
          style={{ backgroundColor: "#e3e9ff", height: "1200px" }}
        >
          <div className="pl-20 pr-20 pb-10">
            <div>
              <Link
                className="flex flex-middle wt-max-content theme-color fs-22 mr-20 pt-10"
                to={`/event/create/${match.params.eventId}/${match.params.rfqId}`}
              >
                <BackIcon className="mr-10 fill-theme curP fBold" />
                Back
              </Link>
            </div>
            <section className="pl-15 mt-10 flex separator" />
            <div className="mt-20 text-center col-1 header-text mb-10">
              Upload RFQs
            </div>
            <div className=" mt-25 Upload-border bg-white">
              <div className="col-75">
                <div className="download-templet">
                  <Button className={"download-button "} onClick={() => this.onClickEventDownloadTemplate(1)}>
                    <span className="flex flex-around pr-20 pl-20">
                      <DownloadIcon width="16" height="16" />
                      Template
                    </span>
                  </Button>
                </div>
                <div
                  style={{ "margin-top": "0px" }}
                  className="fileUpload ml-20"
                >
                  <div className="db-upload-file teg-file">
                    { fileName ? (
                      <label
                        className="teg-file-label"
                        htmlFor="validatedCustomFile"
                      >
                        {fileName}
                      </label>
                    ) : (
                      <label
                        className="teg-file-label"
                        htmlFor="validatedCustomFile"
                      >
                        No file Selected
                      </label>
                    )}
                    <input
                      type="file"
                      name="tegFile"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/csv, text/comma-separated-values, text/csv"
                      id="validatedCustomFile"
                      className="teg-file-input"
                      onClick={(e) => this.handleExcelUpload(e)}
                      onChange={(e) => this.handleFileNameStorage(e)}
                    />
                  </div>
                  <div>
                    <Button
                      className={"upload-button ml-40 "}
                      onClick={() => this.submitUploadedFile()}
                      disabled={!fileName}
                    >
                      Upload Event
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <section>
              <div className="">
                <Table className="upload-rfq-table"striped>
                  <thead>
                    <tr>
                      <th className="upload-td-th upload-th">Event ID</th>
                      <th className="upload-td-th upload-th">RFQs</th>
                      <th className="upload-td-th upload-th">Success/failure</th>
                      <th className="upload-td-th upload-th">Reason</th>
                      <th className="upload-td-th upload-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {eventDetails && eventDetails.number_of_rfqs > 0 && <tr>
                      <td className="upload-td-th">{(eventDetails.event_rfq || {}).event_id}</td>
                      <td className="upload-td-th">{eventDetails.number_of_rfqs}</td>
                      <td className="upload-td-th">{eventDetails.rfq_error_count > 0 ? <span className="error-color fBold">Failure</span> : <span className="success-color">Success</span>} </td>
                      <td className="upload-td-th">{eventDetails.rfq_error_count > 0 ? <span className="error-color fBold">{`${eventDetails.rfq_error_count} Errors`}</span> : ''}
                      {eventDetails.rfq_error_count > 0 && 
                      <>
                      <DownloadIcon className="wt-18 ht-18 ml-20 curP" onClick={() => this.onClickEventDownloadTemplate(2)}/>
                      <Upload onChange={this.onUpload}>
                        <UploadIcon className="wt-18 ht-18 ml-20 curP" onClick={() => this.onClickEventDownloadTemplate(2)}/>
                      </Upload>
                      </>}</td>
                      <td className="upload-td-th">
                        {" "}
                        <TrashIcon
                          width="20"
                          height="20"
                          className="error-color fs-24 fBold ml-5 curP"
                          onClick={this.onCancel}
                        />
                      </td>
                    </tr>}
                    
                    
                  </tbody>
                </Table>
              </div>
            </section>
            <section>
              <div className="wt-150 ml-25 mt-50 fRight mb-50">
                <Button className="button-classic" disabled={eventDetails.rfq_error_count > 0} onClick={this.onNext}>Next</Button>
              </div>
              <div className="wt-150 ml-25 mt-50 fRight mb-50">
                <Button className="button-classic " onClick={this.onClickPrevious}>Previous</Button>
              </div>
            </section>
          </div>
        </div>
      </Sticky>
    );
  }
}

const mapStateToProps = ({ rfq, contracting }) => {
  return {
    eventDetails: rfq.eventDetails || {},
    loader: contracting.loader || false
  }
}
export default connect(mapStateToProps)(UploadRfq);
